module.exports = __webpack_public_path__ + "/login_ui/img/lv-d56a0998209a7a4ebe52c36dbca9b1b4.svg";